namespace advisorop.components.advisor {

    export class InvMeetingSchedulerController {
        // bindings

        puReserveredMeetings: DevExpress.ui.dxPopupOptions;
        dgReserveredMeetings: DevExpress.ui.dxDataGridOptions;
        reserveredMeetings: domains.IMeeting[] = [];

        static $inject = ["investorService", "generalService"];
        constructor(
            private invSrv: services.InvestorService,
            private generalService: services.GeneralService
        ) {
            this.puReserveredMeetings = {

            }
            this.dgReserveredMeetings = {
                bindingOptions: {
                    dataSource: "vm.reserveredMeetings"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                paging: { pageSize: 25 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: false,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                noDataText: "No Meetings Reservered",
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    //{ dataField: "documentTypeDesc", caption: "Document Type", width: 150 },
                    //{ dataField: "dateCreated", caption: "Date Created", dataType: "date", width: 120 },
                    //{ dataField: "version", caption: "Ver.", width: 40 },
                    //{ dataField: "extension", caption: "Ext.", width: 40 },
                    //{ dataField: 'enableDisableStatus', caption: 'File Status', width: 70 },
                    //{ dataField: "id", caption: "#", cellTemplate: "colActions", width: 140 }
                ],
            };
        }
        
        // loading methods

        loadReserveredMeeting(): void {
        //    this.reserveredMeetings = [];
        //    this.invSrv.
        }

        // overrides
        $onChanges(evt): void {
        }

        $onInit(): void {
            this.loadReserveredMeeting();
        }
    }

    class InvMeetingScheduler implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
            };
            this.controller = InvMeetingSchedulerController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/investor-module/components/inv-meeting-scheduler.html";
        }

    }
    angular.module(Constants.APP).component("invMeetingScheduler", new InvMeetingScheduler());
}